export default function generateMaxLengthValidateFn(maxLength: number) {
  const validateFn = (value: string) => {
    return (value.length <= maxLength) || `${maxLength} character limit hit. (${value.length} chars)`
  };
  return validateFn;
};
